/**
 * 正则
 *  vaildW  包含数字， 大小写， 下划线
 */
export const vaildW = /^\w+$/
